export default "__VITE_ASSET__COiqbCNU__"